import type { NodeT } from 'fable/flowEditor';

import { FlowNodeTypes } from '../components/types';

export function getActionNodes<TNode>(actions: NodeT<TNode>[]): string[] {
  const actionNodes = actions.filter(
    (node: NodeT) => node.nodeType === FlowNodeTypes.ACTION,
  );

  return actionNodes.map<string>((node: NodeT<TNode>) => node.id);
}
